// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yodiwo-button {
  --matter-helper-theme: var(--matter-theme-rgb, var(--matter-primary-rgb, 33, 150, 243));
  position: relative;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-sizing: border-box;
  margin: 0;
  border: none;
  border-radius: 4px;
  padding: 0 8px;
  min-width: 64px;
  height: 36px;
  vertical-align: middle;
  text-align: center;
  text-overflow: ellipsis;
  color: rgb(var(--matter-helper-theme));
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  cursor: pointer;
}
.yodiwo-button img {
  max-width: 50%;
  max-height: 50%;
  object-fit: contain;
}
.yodiwo-button::-moz-focus-inner {
  border: none;
}
.yodiwo-button::after,
.yodiwo-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  opacity: 0;
}
.yodiwo-button:not(.no-hover)::before {
  background-color: rgb(var(--matter-helper-theme));
  transition: opacity 0.2s;
}
.yodiwo-button:not(.no-hover)::after {
  background: radial-gradient(circle at center, currentColor 1%, transparent 1%) center / 10000% 10000% no-repeat;
  transition: opacity 1s, background-size 0.5s;
}
.yodiwo-button:not(.no-hover):hover::before {
  opacity: 0.2;
}
.yodiwo-button:not(.no-hover):focus::before {
  opacity: 0.25;
}
.yodiwo-button:not(.no-hover):hover:focus::before {
  opacity: 0.3;
}
.yodiwo-button:not(.no-hover):active::after {
  opacity: 0.25;
  background-size: 100% 100%;
  transition: background-size 0s;
}
.yodiwo-button:disabled {
  color: rgba(var(--matter-onsurface-rgb, 0, 0, 0), 0.38);
  background-color: transparent;
  cursor: initial;
}
.yodiwo-button:disabled::before,
.yodiwo-button:disabled::after {
  opacity: 0;
}
.yodiwo-icon-button {
  font-size: 16px;
  padding: 0 10px;
  color: white;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yodiwo-icon-button:hover {
  opacity: 0.5 !important;
}
i.center {
  display: flex !important;
  align-items: center;
  justify-content: center;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
